// UI IMPORT
import { Button, Icon, Input, Loader, Password } from "../../ui";

// PROJECT IMPORT
import { useLoginMutation } from "./authApi";
import { showToaster } from "../../helperFunctions";
import { LoginFormTypes } from "./types";

// THIRD - PARTY IMPORT
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";

const Login = () => {
  const [login, { isLoading }] = useLoginMutation();

  const schema = yup.object({
    emailId: yup.string().required("Please enter a email Id"),
    password: yup.string().required("Please enter a password"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver<LoginFormTypes>(schema),
  });

  const onSubmit = async (values: LoginFormTypes) => {
    try {
      const res = await login(values).unwrap();
      showToaster(res?.message);
    } catch (err: any) {
      console.error("Login Error =-=>", err);
    }
  };

  
  const logo: any = process.env.REACT_APP_OUTER_LOGO;

  if (isLoading) {
    return (
      <>
        <div className="w-[100vw] h-[100vh] z-[9999] flex items-center justify-center">
          <Loader />
        </div>
      </>
    );
  }

  return (
    <>
      <form
        className="grid  h-screen login-wrapper "
        // className="grid grid-cols-2 md:grid-cols-1 sm:grid-cols-1 h-screen"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Icon name="CloudImg" className="LoginOne" />
        <Icon name="BuildingImg" className="LoginTwo" />
        <div className="bg-[#fff] flex">
          <div className="login-main rounded-xl bg-chatlook-white w-4/12 md:w-7/12 sm:w-11/12  m-auto ">
            <div className="flex items-center justify-center">
              <div className="flex items-center justify-center w-[140px] ">
                {/* <Icon className="w-36" name="LogoLastIcon" /> */}
                <img
                  src={`data:image/svg+xml;utf8,${encodeURIComponent(logo)}`}
                  alt="Logo"
                />
              </div>
            </div>
            <div className="welc-text text-center my-6">
              <h4>Welcome Back</h4>
              <p className="mt-1">Login to your account</p>
            </div>
            <div className="space-y-5 pb-10">
              <Input
                className="!w-full"
                inputClassName="!h-12"
                icon="EmailIcon"
                name="emailId"
                placeholder="Email Address"
                errors={errors}
                register={register}
              />
              <Password
                className="!w-full"
                inputClassName="!h-12"
                name="password"
                placeholder="Password"
                errors={errors}
                register={register}
              />
            </div>
            <div className="flex items-center justify-center w-full">
              <Button type="submit" className="!px-20">
                Login
              </Button>
            </div>
          </div>
        </div>
        {/* <div className="bg-chatlook-darkblue flex md:hidden sm:hidden items-center">
          <div className="w-8/12 m-auto">
            <Icon name={"Logohero"} className="max-w-full m-auto" />
            <p className="text-ev-white text-center mt-4">
              Login is the act of entering credentials to access an account or
              system.
            </p>
          </div>
        </div> */}
      </form>
    </>
  );
};

export default Login;
